// Migrated 1:1 from @nexato/nx-core-module (lib/components/files-icon.component.ts), #672.
import { Component, input, computed } from '@angular/core';

@Component({
    selector: 'app-files-icon',
    template: `
        <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
            <path d="M4.83,17.5c-.83,0-1.65-.31-2.28-.94-.61-.61-.95-1.42-.95-2.28s.34-1.67.95-2.28l4.47-4.47s0,0,0,0l2.24-2.24c.71-.71,1.95-.71,2.65,0,.35.35.55.83.55,1.33s-.2.97-.55,1.33l-5.43,5.42c-.21.21-.54.21-.74,0s-.21-.54,0-.74l5.43-5.43c.16-.16.24-.36.24-.58s-.09-.43-.24-.58c-.31-.31-.85-.31-1.16,0l-6.71,6.71c-.41.41-.64.96-.64,1.54s.23,1.13.64,1.53c.82.82,2.25.82,3.07,0L14.42,7.75c1.42-1.42,1.42-3.72,0-5.14-1.42-1.42-3.72-1.42-5.14,0l-6.92,6.92c-.21.21-.54.21-.74,0s-.21-.54,0-.74L8.54,1.87C10.36.04,13.34.04,15.16,1.87c1.83,1.83,1.83,4.8,0,6.63l-8.06,8.06c-.63.63-1.45.94-2.28.94Z"/>
        </svg>
        @if (count() !== undefined) {
            <span>{{count()}}</span>
        }
    `,
    styles: [`
        :host {
            display: flex;
            float: left;
        }
        :host([hidden]) {
            display: none !important;
        }
        svg {
            height: 14px;
            margin-top: 3px;
            margin-right: 0.125rem;
        }
    `],
    host: {
        '[attr.hidden]': 'hidden()'
    }
})
export class FilesIconComponent {

    count = input<number | undefined>();

    hidden = computed(() => !this.count() ? true : null);

}
